/** Build identity, stamped by the Dockerfile (GIT_SHA / BUILD_TIME) — "dev" under `pnpm dev`. */
export const BUILD_SHA: string = import.meta.env.VITE_BUILD_SHA ?? "dev";
export const BUILD_TIME: string = import.meta.env.VITE_BUILD_TIME ?? "";
export const BUILD_LABEL = BUILD_TIME ? `BUILD ${BUILD_SHA} · ${BUILD_TIME}` : `BUILD ${BUILD_SHA}`;
